import React, { useEffect } from 'react'
import { History, Location } from 'history'
import { Link, generatePath } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import { Table, Button, Popconfirm, Divider } from 'antd'
import { Page } from '../../components/Page'
import { Layout } from '../../components/Page/Layout'
import { ADD_HOOK, HOOK_DETAIL } from '../../routes'
import { HookActions } from '../../features/hook/actions'
import { getHooks } from '../../features/hook/selectors'
import { Hook } from '../../features/hook/types'
import { Title } from '../../components/Text'

type Props = {
  history: History
  location: Location<{ showInDashboard?: boolean } | undefined>
}

export const HooksContainer = ({ history }: Props) => {
  const dispatch = useDispatch()
  const hooks = useSelector(getHooks)

  useEffect(() => {
    dispatch(HookActions.fetchHooks())
  }, [dispatch])

  const editHook = (h: Hook) => {
    history.push(generatePath(HOOK_DETAIL, { hookId: h.id }))
  }

  const dataSource = _.map(hooks, (hook: Hook) => {
    return {
      id: hook.id,
      key: hook.id,
      image: hook.image,
      name: hook.name,
      title: hook.title,
      button: hook.button,
      paymentTemplateId: hook.paymentTemplateId
    }
  })

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title'
    },
    {
      title: 'Action',
      key: 'action',
      // eslint-disable-next-line react/display-name
      render: (_text: string, record: Hook) => (
        <span>
          <Button type="link" onClick={() => editHook(record)}>
            Edit
          </Button>
          <Divider type="vertical" />
          <Popconfirm
            title="Sei sicuro di voler eliminare questo Hook?"
            onConfirm={() => dispatch(HookActions.startDeletingHook(record.id))}
            onCancel={() => _.noop()}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link">Delete</Button>
          </Popconfirm>
        </span>
      )
    }
  ]

  return (
    <Page>
      <Layout>
        <Title size="XL">Hooks</Title>
        <Table dataSource={dataSource} columns={columns} />
        <div>
          <Link to={ADD_HOOK}>
            <Button>Nuovo</Button>
          </Link>
        </div>
      </Layout>
    </Page>
  )
}
